const APPLICATION_LOCALES = [
  "de-de",
  "en-us",
  "es-es",
  "fr-fr",
  "ja-jp",
  "ko-kr",
  "zh-tw",
];

const PAYPAL_LOCALE_MAP = {
  "de-de": "de_DE",
  "en-us": "en_US",
  "es-es": "es_ES",
  "fr-fr": "fr_FR",
  "ja-jp": "ja_JP",
  "ko-kr": "ko_KR",
  "zh-tw": "zh_TW",
} as any;

export default new (class Locale {
  getLocale(): string {
    const matchedString = window.location.pathname.split("/");
    if (APPLICATION_LOCALES.includes(matchedString[1])) {
      return matchedString[1];
    }

    return "";
  }
  // Paypal iframe の言語を切り替えるには Paypal がサポートしているロケールコードを指定する必要がある
  // 参照 : https://developer.paypal.com/docs/archive/nvp-soap-api/locale-codes/
  getPaypalLocale(locale: string): string {
    if (APPLICATION_LOCALES.includes(locale)) {
      return PAYPAL_LOCALE_MAP[locale];
    }

    return PAYPAL_LOCALE_MAP["en-us"];
  }
})();
